<template>
    <div class="flex">
        <input type="file" ref="file" id="file" style="display: none" @change="onChange()" :accept="accept" />
        <l-button type="success" @click="$refs.file.click()">Last opp fil</l-button>
        <div class="ml-2 pt-1 pb-1 pl-6 pr-6 border border-dashed font-bold text-xs" :class="hoverBorder" @dragover.stop.prevent="hover = true" @dragenter.stop.prevent @dragleave.stop.prevent="hover = false" @drop.stop.prevent="onDrop">Eller dra filen hit...</div>
    </div>
</template>

<script>
import { LButton } from "@/components/forms";
export default {
    name: "LUpload",
    props: ["icon", "accept"],
    components: {
        LButton
    },
    data() {
        return {
            hover: false
        };
    },
    computed: {
        hoverBorder() {
            if (this.hover) return "border-red-400";
            return "";
        }
    },
    methods: {
        onDrop(e) {
            this.hover = false;
            this.$refs.file.files = e.dataTransfer.files;
            this.onChange();
        },
        onChange() {
            this.$emit("on-change", this.$refs.file.files);
            this.$refs.file.type = "text";
            this.$refs.file.type = "file";
        }
    }
};
</script>
